import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgX = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M22.494 21.256a.875.875 0 0 1-1.238 1.238L14 15.237l-7.256 7.257a.876.876 0 0 1-1.238-1.238L12.763 14 5.506 6.744a.875.875 0 1 1 1.238-1.238L14 12.763l7.256-7.257a.876.876 0 0 1 1.238 1.238L15.237 14l7.257 7.256Z" />
  </svg>
);
export default SvgX;
